import request from '@/common/request'
export default {
  getHolidayInfo:()=>{
    return request({
      url:'/holidayInfo/getList',
      method:'post'
    })
  },
  saveHolidayInfo: data => {
    return request({
      url: '/holidayInfo',
      method: 'post',
      data
    })
  },
  deleteHolidayInfo: dynaSeg => {
    return request({
      url: `/holidayInfo/${dynaSeg.id}`,
      method: 'delete'
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/modules/holidayConfig.js